import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white number-of-tickets-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing heigth-chart-realtime" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-sm-flex align-items-center justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Gravações por tempo")
], -1)
const _hoisted_4 = {
  id: "numberOfTicketsChart",
  class: "chart"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-40" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-20" }, " Este gráfico representa a quantidade de gravações com base na duração de cada uma, elas estão agrupadas nos valores descritos acima. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "251",
          options: _ctx.numberOfTicketsChart,
          series: [{name: 'Quantidade', data: Object.values(_ctx.getTimers)}]
        }, null, 8, ["options", "series"])
      ]),
      _hoisted_5
    ])
  ]))
}